import React from 'react';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './CreationForm.module.scss';

interface ICreationForm {
	isVisible: boolean;
}

const CreationForm: React.FC<ICreationForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="CreationForm">
			<InputFields />
		</div>
	);
};

export default CreationForm;
